import * as React from 'react';
import styled from 'styled-components';
import { environment } from '@doltech/core/lib/environment/environment';
import { fixRedirectUrl } from '@doltech/utils/lib/url';

import { colorsV2 } from '../../../figma/colors-v2';

const CTAButtonMain = styled.div`
  button {
    width: 124px;
    background-color: ${colorsV2.primary100};
    border-color: ${colorsV2.primary100};
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    white-space: nowrap;
    height: 42px;
    color: white;
    display: inline-block;
    outline: none;
    cursor: pointer;
    user-select: none;
    padding-left: 1em;
    padding-right: 1em;
    border-width: 1px;
    border-style: solid;
    text-decoration: none;
  }
`;

export const DefaultCTAButton = () => {
  return (
    <CTAButtonMain className="cta-actions">
      <a
        href={fixRedirectUrl(`${environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME}/lien-he`)}
        target="_blank"
        rel="noopener noreferrer"
        className="action-link"
      >
        <button>Inbox DOL</button>
      </a>
    </CTAButtonMain>
  );
};
